import { useNavigate, useParams } from "react-router";
import {
	isValidLang,
	type Lang,
	ROUTE_SLUGS,
	type RouteKey,
} from "@/config/routes";

export function useLocalizedNavigate() {
	const { lang } = useParams<{ lang: string }>();
	const navigate = useNavigate();
	const currentLang: Lang = lang && isValidLang(lang) ? lang : "pl";

	return (routeKey: RouteKey, ...segments: string[]) => {
		const slug = ROUTE_SLUGS[routeKey][currentLang];
		const parts = [`/${currentLang}`, slug, ...segments].filter(Boolean);
		navigate(parts.join("/"));
	};
}
